import { createFileRoute, redirect } from "@tanstack/react-router";

// Catch-all redirect: /blogs/<blog> → /field-notes/<blog>
export const Route = createFileRoute("/blogs/$blog/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/field-notes/$blog",
      params: { blog: params.blog },
      statusCode: 301,
    });
  },
});
